<template>
<div class="card">
  <div class="card-header">
    <h5>
      Definição de termos e documentos no Evento.
    </h5>
  </div>
  <div class="card-content">
    <p>
      As definições abaixo são para o estado de: <strong>{{project.company.address.state}}</strong>
    </p>
    <div class="form-group">
      <p class="category">
        De qual concessionária serão os termos?
      </p>
      <RadioCompaniesDocuments
        :currentTerms="currentTerms"
        v-model="event.doc.companyTerms"
      ></RadioCompaniesDocuments>
    </div>
    <div class="form-group">
      <p class="category">
        Haverá separação entre o termo de comodato e o ticket do cliente?
      </p>
      <small>
        Ao ativar, o termo de comodato será impresso por outro botão.
      </small>
      <YesNoRadio v-model="event.doc.registerCustomerTicketDocument"></YesNoRadio>
    </div>
    <div
      class="form-group"
      v-if="event.doc.registerCustomerTicketDocument"
    >
      <p class="category">
        Quantidade de dias para o agente comunitário visitar a casa do cliente?
      </p>
      <small>
        "O processo será realizado por um dos nossos Agentes Comunitários que visitará sua residência nos próximos XX
        dias"
      </small>
      <input
        type="text"
        v-model="event.doc.daysToVisit"
        class="form-control"
      >
      <small>Insira exatamente como deverá ser exibido no documento</small>
    </div>
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import PSwitch from 'components/UIComponents/Switch.vue'
import YesNoRadio from '../YesNoRadio'
import RadioCompaniesDocuments from '../Project/RadioCompaniesDocuments'

export default {
  name: 'DocumentsEventFormComponents',
  components: {
    PSwitch,
    YesNoRadio,
    RadioCompaniesDocuments
  },
  props: {
    currentState: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters('project', ['currentTerms', 'project']),
    event: {
      get () {
        return this.$store.state.events.one
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Trg/Event/DocumentsEventFormComponents.vue